var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25769 7.88646C6.70952 7.88646 7.88646 6.70952 7.88646 5.25769C7.88646 3.80585 6.70952 2.62891 5.25769 2.62891C3.80585 2.62891 2.62891 3.80585 2.62891 5.25769C2.62891 6.70952 3.80585 7.88646 5.25769 7.88646Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2475V13.5619C0 13.8039 0.196173 14 0.43813 14H10.077C10.319 14 10.5151 13.8039 10.5151 13.5619V12.2475C10.5151 10.3117 8.94585 8.74244 7.01008 8.74244H3.50504C1.56926 8.74244 0 10.3117 0 12.2475ZM8.87293 5.25382C10.2749 5.1771 11.3885 3.99235 11.3537 2.56373C11.3216 1.24156 10.2526 0.109542 8.93395 0.00803169C7.69257 -0.0875419 6.6139 0.679829 6.2403 1.77724C6.22054 1.83527 6.2553 1.89758 6.31373 1.91608C7.70078 2.35552 8.7113 3.62993 8.75901 5.14533C8.76094 5.2066 8.81172 5.25716 8.87293 5.25382Z",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77426 7.93283C9.51379 8.23937 10.8977 9.57515 11.2825 11.2856C11.2936 11.3348 11.3361 11.3699 11.3865 11.3699H13.5439C13.7848 11.3699 13.982 11.1771 13.982 10.9317V9.61734C13.982 7.6852 12.4135 6.1123 10.477 6.1123H8.73609C8.68758 6.1123 8.64638 6.14495 8.63356 6.19176C8.46951 6.79111 8.14952 7.32711 7.71781 7.74997C7.65301 7.81346 7.68492 7.91711 7.77426 7.93283Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/assigned.f6a92a9d058f76288127da1fcba44fea.svg";
export { ForwardRef as ReactComponent };